
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import companyCreateEditDialog from "./CompanyCreateEditDialog.vue";
import companyInfoDialog from "@/components/info/CompanyInfoDialog.vue";
import { TextBooleanDateTimeColumnConfig } from "@/components/controls/catalogueGrid/columns/textBooleanDateTimeColumnConfig";
import { DateColumnConfig } from "@/components/controls/catalogueGrid/columns/dateColumnConfig";
import { BooleanColumnConfig } from "@/components/controls/catalogueGrid/columns/booleanColumnConfig";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //панель выбора страницы
    showPageSizeSelector: { required: false, default: true },
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
  },
  computed: {
    companyCreateEditDialog(): any {
      return companyCreateEditDialog;
    },
    companyInfoDialog(): any {
      return companyInfoDialog;
    },
  },
  data() {
    return {
      editingConfig: new TableEditingConfig({
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        confirmDelete: true,
        allowDataFill: false,
        allowClearFilter: true,
        allowDeleteMultipleRows: false,
        showInfo: true,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new IntegerColumnConfig({
          dataField: "id",
          caption: "Код",
          readOnly: true,
          editVisible: false,
        }),
        new TextColumnConfig({
          dataField: "name",
          caption: "Наименование",
          validationRules: [requiredRule],
        }),
        new BooleanColumnConfig({
          dataField: "isActive",
          caption: "Признак активности",
        }),
        new IntegerColumnConfig({
          dataField: "modulesMask",
          caption: "Битовая маска компании",
          readOnly: false,
        }),
        new DateColumnConfig({
          dataField: "licenseExpirationDate",
          caption: "Дата",
          mode: "datetime",
          validationRules: [requiredRule],
          sortOrder: "desc",
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        heightScroll: !this.selectMode ? "calc(100vh - 205px)" : "400px",
        horizontalScroll: true,
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "single",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
